'use client';

import { useParams } from 'next/navigation';

import Button from '@/components/ui/Button';
import ButtonLink from '@/components/ui/ButtonLink';
import Text from '@/components/ui/Text';
import { COMMON_I18N } from '@/lib/i18n/commonI18n';
import { resolveAppLocale } from '@/lib/i18n/routing';

const ErrorMessage = ({ reset }: ErrorMessageProps) => {
  const params = useParams();
  const locale = resolveAppLocale(params.locale as string);
  const i18n = COMMON_I18N[locale];

  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="text-center max-w-md px-8">
        <Text as="p" variant="sectionEyebrow" className="mb-3">
          {i18n.errorEyebrow}
        </Text>
        <Text as="h1" variant="sectionTitle" className="mb-4">
          {i18n.errorTitle}
        </Text>
        <Text as="p" variant="paragraph" className="mb-8">
          {i18n.errorMessage}
        </Text>
        <div className="flex flex-col tablet:flex-row gap-4 justify-center">
          {reset && (
            <Button variant="primary" onClick={reset}>
              {i18n.tryAgain}
            </Button>
          )}
          <ButtonLink href="/" variant="ghost">
            {i18n.backToHome}
          </ButtonLink>
        </div>
      </div>
    </div>
  );
};

export default ErrorMessage;

type ErrorMessageProps = {
  reset?: () => void;
};
